import React, { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../auth'
import { useLang } from '../i18n'

export function LoginPage() {
  const { t } = useLang()
  const { login } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const activated = searchParams.get('activated') === '1'
  const [account, setAccount] = useState('')
  const [password, setPassword] = useState('')
  const [remember, setRemember] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(account.trim(), password, remember)
      navigate('/', { replace: true })
    } catch (err: unknown) {
      const e = err as Error & { status?: number }
      setError(e.message || t('errorLoginFailed'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <div style={{
        width: '340px', padding: '32px', border: '1px solid var(--border)',
        borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', background: 'var(--bg-surface)',
      }}>
        <h2 style={{ margin: '0 0 24px 0', fontSize: '20px', color: 'var(--text-primary)', textAlign: 'center' }}>
          {t('loginTitle')}
        </h2>

        {activated && (
          <div style={{
            padding: '10px 12px', marginBottom: '16px', background: 'var(--success-bg)',
            border: '1px solid var(--success)', borderRadius: '4px', color: 'var(--success)', fontSize: '13px',
          }}>
            {t('activateSuccess')}
          </div>
        )}

        {error && (
          <div style={{
            padding: '10px 12px', marginBottom: '16px', background: 'var(--danger-bg)',
            border: '1px solid var(--danger)', borderRadius: '4px', color: 'var(--danger)', fontSize: '13px',
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{t('loginAccount')}</label>
            <input
              type="text" value={account} onChange={(e) => setAccount(e.target.value)}
              placeholder={t('loginAccount')} required
              style={{ padding: '8px 10px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '14px' }}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{t('loginPassword')}</label>
            <input
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              placeholder={t('loginPassword')} required
              style={{ padding: '8px 10px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '14px' }}
            />
          </div>

          <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '13px', color: 'var(--text-secondary)', cursor: 'pointer' }}>
            <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
            {t('loginRemember')}
          </label>

          <button type="submit" disabled={loading} style={{
            padding: '10px', background: loading ? 'var(--text-muted)' : 'var(--accent)',
            color: 'var(--accent-contrast)', border: 'none', borderRadius: '4px', fontSize: '14px',
            fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
          }}>
            {loading ? t('loading') : t('loginSubmit')}
          </button>

          <div style={{ textAlign: 'center' }}>
            <Link to="/forgot-password" style={{ fontSize: '13px', color: 'var(--text-primary)', textDecoration: 'underline' }}>
              {t('forgotPassword')}
            </Link>
          </div>
        </form>
      </div>
    </div>
  )
}
